import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-circle-with-check-fill",
  "use": "icon-circle-with-check-fill-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-circle-with-check-fill\"><g id=\"icon-circle-with-check-fill_Layer_3\"><path d=\"M24,0C10.745,0,0,10.745,0,24s10.745,24,24,24s24-10.745,24-24S37.255,0,24,0z M30.627,22.957l-9.54,9.54   l-0.005-0.005l-0.531,0.529l-0.007-0.006l-0.007,0.006l-1.19-1.188l0.007-0.008l-7.759-7.759l2.195-2.195l6.768,6.77l7.875-7.876   l-0.009-0.009l5.776-5.777l2.201,2.202L30.627,22.957z\" fill=\"#241F20\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol